<script setup lang="ts">
import type { AxiosError } from 'axios'
import { PostContentsType } from '@store'

definePageMeta({
  layout: 'one-column',
})

const { t } = useI18n()
const route = useRoute()
const postStore = usePostStore()
const { post } = storeToRefs(postStore)
const { onPage } = useShowPostErrorMessage()
const err = ref<AxiosError>()

onMounted(async () => {
  if (post.value) {
    await postStore.fetchCommentsAndReplies(
      {
        ...initPostState.commentsAndReplies.payload,
        cmtyNttSn: Number(route.params.id),
      },
      true
    )
  }
})

const { data: _post } = await useAsyncData(
  `post:${route.params.id}`,
  async () => {
    try {
      const result = await postStore.fetchPost({
        cmtyNttSn: Number(route.params.id),
      })
      return Promise.resolve(result)
    } catch (_err) {
      err.value = _err as AxiosError
      return Promise.reject(_err)
    }
  }
)

if (_post.value) {
  useSetSEO({
    useHeadArgs: [
      {
        title: _post.value.nttSj,
        meta: [
          {
            name: 'description',
            content: useGetMaxThreeParagraphTexts(_post.value.nttCn),
          },
        ],
      },
    ],
    useSeoMetaArgs: [
      {
        ogTitle: _post.value.nttSj,
        ogDescription: useGetMaxThreeParagraphTexts(_post.value.nttCn),
        ogImage: useGetPostThumbUrl(_post.value),
      },
    ],
  })
}

if (err.value) {
  onPage(Number(route.params.id), err.value)
}

// 포스트 삭제시 뒤로가기
watch(
  () => post.value,
  async (cur) => {
    if (cur === null) {
      // 삭제 액션시 컨펌 모달이 라우트 히스토리에 남는 문제로 히스토리백 2번함
      await useNavigations({ type: 'back' })
      await useNavigations({ type: 'back' })
    }
  }
)
</script>

<template>
  <div class="page-post post-detail">
    <NovaBoxPost
      v-if="post && post.bkFlag === '0'"
      :source="post"
      :view-type="PostContentsType.DETAIL"
    />

    <NovaBoxEmptyMessage
      v-if="!post || (post && post.bkFlag === '1')"
      :message="t('statusMessages.postDetail.error.notFound')"
      :fill="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-post {
  display: flex;
  flex-direction: column;
  padding: 40px 0;

  :deep(.post.view-type-detail) {
    max-height: initial;
  }

  @include mobile {
    padding: 25px 10px;
  }
}
</style>
